import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { sdk } from '@/services';

const SubscriptionService = sdk.getService('SubscriptionService');

export const useMutateUserSubscriptions = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync: setUserVisibleSubscriptions, isPending } = useMutation({
    mutationFn: ({ userId, subscriptionIds }: { userId: string; subscriptionIds: string[] }) =>
      SubscriptionService.setUserVisibleSubscriptions(userId, subscriptionIds),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['students', 'subscriptions', variables.userId] });
      message.success(t('CHANGES_SAVED'));
    },
    onError: () => message.error(t('DEFAULT_ERROR'))
  });

  return { setUserVisibleSubscriptions, isPending };
};
